



































































import { FORGOT_PASSWPRD } from "@/queries/anonymous/mutation.graphql";

import Vue from "vue";
export default Vue.extend({
  data: () => ({
    form: {
      email: ""
    },
    sent: false,
    isLoading: false
  }),
  methods: {
    forgot() {
      this.isLoading = true;
      this.$apollo
        .mutate({
          mutation: FORGOT_PASSWPRD,
          variables: {
            ...this.form
          }
        })
        .then((data: any) => {
          this.isLoading = false;
          if (data.data.forgotPassword.affected_rows) {
            this.sent = true;
          }
        })
        .catch(error => {
          console.log(error.graphQLErrors);

          this.isLoading = false;
          this.form.email = "";
          this.$toastr.e(error.graphQLErrors[0].message);
        });
    }
  }
});
